import React from 'react';
import Feature from './Feature';
import { stFEATURES } from './NavBar';
import Section from "./Section";

const FeaturesSection: React.FC = () => {
    return (
        <Section id={stFEATURES}><>
            <h1>Key Features</h1>
            <Feature title="Secure and Private"
                     img="equiquill-secure.png"
                     content={(
                         <>
                             <p>EquiQuill is designed to keep your thoughts and feelings safe and secure. Your
                                 data is always encrypted and secure. We use the
                                 latest encryption technology to ensure that your journal entries are for your eyes
                                 only.</p>
                             Read more at <a href={'/#privacy'}>www.equiquill.com/#privacy</a>
                         </>
                     )}
            />
            <Feature
                title="Interactive Interface"
                direction="right"
                img="equiquill-screenshot1.png"
                content='An engaging and intuitive interface, transforming journaling into a delightful experience. It features entertaining guidance, a wide range of emojis, and the ability to create custom images, all inspired by your journal entries.'
            />
            <Feature
                title='Quill Awesome!"'
                img='equiquill-screenshot2.png'
                content='The only interactive application dedicated to journaling that truly emulates the sensation of pen writing, guiding you towards a more reflective and serene pace. It encourages a natural flow of emotions and thoughts, just as if you were gliding a pen across paper, capturing your innermost reflections with ease and authenticity.'
            />
            <Feature
                title={(
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        height: '50px'
                    }}>
                        <img
                            style={{
                                height: '50px',
                                width: 'auto'
                            }}
                            src={'/api_logo_cptblWith_strava_horiz_gray.svg'}
                        />
                    </div>
                    )}
direction = 'right'
img = 'equiquill-screenshot-3.png'
content = {'Strava Integration features an automatic journal entry creation based on your Strava activities. This includes establishing a mood based on your ride\'s "karma" compared to others. Additionally, it will generate a picture to be attached to your Strava activity.'}
            />
            <Feature title="Your Data secure in Canada"
                     img="canada-flag.jpg"
                     content={(
                         <>
                             <p>
                                 EquiQuill is a proudly Canadian company, ensuring that all user data is securely hosted
                                 in secure Google facilities, in Montreal, Quebec. We adhere to strict Canadian privacy laws,
                                 including the **Personal Information Protection and Electronic Documents Act (PIPEDA)** ,
                                 as well as **Quebec’s Law 25 (formerly Bill 64)**. Our infrastructure meets stringent
                                 compliance standards, ensuring that your personal and sensitive information remains
                                 protected and under Canadian jurisdiction.
                             </p>
                             Read more at <a href={'/#privacy'}>www.equiquill.com/#privacy</a>
                         </>
                     )}
            />
            <Feature
                title='More to come'
                img='equiquill-more-to-come.png'
                content={'Our application is in its exciting early stages, and we\'re dedicated to its evolution based on your valuable feedback. In the near future, look for new features that will: allow you to dive deeper into your journal entries; give you weekly, monthly, and yearly summaries; provide better image generations; export your data; and more ongoing enhancements to enrich your experience'}
                direction={"right"}
             />
        </></Section>
    );
};

export default FeaturesSection;